"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCustomRegex = void 0;
var isCustomRegex = function (value, regex) {
    try {
        return regex.test(value.trim());
    }
    catch (error) {
        throw new Error("custom regex failed");
    }
};
exports.isCustomRegex = isCustomRegex;
//# sourceMappingURL=isCustomRegex.js.map